import { authReducer as auth } from 'redux-implicit-oauth2'
import { routerReducer as routing } from 'react-router-redux'
import { combineReducers } from 'redux'
import authStatus from './authStatus'
import me from './me'
import types from './types'
import projects from './projects'
import segments from './segments'
import headers from './headers'
import reports from './reports'

const reducers = {
  routing,
  auth,
  authStatus,
  me,
  types,
  projects,
  headers,
  segments,
  reports,
}

export default combineReducers(reducers)



// WEBPACK FOOTER //
// ./ducks/index.js